import { modalContainerCore } from './core';
/**
 * 
 * ModalContainer is not an Adobe Core component. This export is for the custom modal js/css in ../aem65/components/content/modalcontainer
 * 
 */



/**
 * Collects the Adobe core and ehi-core Container Component clientlibs code to create a full cheerio.
 * @type {Object}
 */
export const modalContainerCheerio = {
	/**
	 * init method to trigger running of the full cheerio code
	 * @return {void}
	 */
  init() {
    modalContainerCore.init();
  }
};
